/**
 * Cálculo padrão da Calculadora Solar (proposta tipo padrão).
 * kWp = kWh ÷ (horas de sol × dias × fator de perda 20%).
 */

export const HORAS_SOL = 5
export const DIAS_MES = 30
export const FATOR_PERDA = 0.8

export function calcularSistemaPadrao({ kwh, potenciaModuloWp, kit }) {
  const consumo = Number(kwh) || 0
  const potenciaWp = Number(potenciaModuloWp) || 0
  const projetoKwp = consumo / (HORAS_SOL * DIAS_MES * FATOR_PERDA)
  const quantidadePaineis = potenciaWp > 0 ? Math.ceil(projetoKwp / (potenciaWp / 1000)) : 0
  const inversor = projetoKwp * 0.9
  return {
    projetoKwp: parseFloat(projetoKwp.toFixed(2)),
    quantidadePaineis,
    inversor: parseFloat(inversor.toFixed(2)),
    valorKit: Number(kit?.valor_kit) || 0,
    totalComPorcentagem: Number(kit?.total) || 0
  }
}

export function kitMaisProximo(kits, kwh) {
  const lista = Array.isArray(kits) ? kits : []
  if (!lista.length) return null
  const alvo = Number(kwh) || 0
  return lista.reduce((melhor, kit) => {
    const d = Math.abs(Number(kit.kwh) - alvo)
    const dm = Math.abs(Number(melhor.kwh) - alvo)
    return d < dm ? kit : melhor
  })
}
